module.exports = __webpack_public_path__ + "img/data3.a1c91b51.png";